import { useState } from 'react';
import { useConfig } from '../../context/ConfigContext';
import { useLanguage } from '../../context/LanguageContext';
import { ShareModal } from '../share';
import styles from './Footer.module.css';

export default function Footer() {
    const { totalPrice } = useConfig();
    const { t } = useLanguage();
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);

    const handleShareClick = () => {
        setIsShareModalOpen(true);
    };

    const handleCloseShareModal = () => {
        setIsShareModalOpen(false);
    };

    return (
        <>
            <footer className={styles.footer}>
                <div className={styles.priceContainer}>
                    <span className={styles.label}>{t('totalPrice')}</span>
                    <span className={styles.price}>${totalPrice.toLocaleString()}</span>
                </div>
                <div className={styles.actions}>
                    <button
                        className={styles.actionBtn}
                        onClick={handleShareClick}
                    >
                        {t('share')}
                    </button>
                    <button className={`${styles.actionBtn} ${styles.primary}`}>
                        {t('save')}
                    </button>
                </div>
            </footer>

            {/* 分享模态框 */}
            <ShareModal
                isOpen={isShareModalOpen}
                onClose={handleCloseShareModal}
            />
        </>
    );
}
